import i18n from 'i18next';

export const WEBVIEW_VERSIONS= [
  { value: '01', label: i18n.t('version 1') },
  { value: '02', label: i18n.t('version 2') },
];

export const YES_NO_OPTIONS = [
  { value: true, label: i18n.t('Yes') },
  { value: false, label: i18n.t('No') },
];

export const SUPPORTING_PARTICIPATION_FORMAT = [
  { value: 'voice', label: i18n.t('Voice') },
  { value: 'text', label: i18n.t('Text') },
];
export const LIST_OF_STATUTS = [
  { value: 'draft', label: i18n.t('Draft') },
  { value: 'ready', label: i18n.t('Ready') },
  { value: 'archived', label: i18n.t('Archived') },
  { value: 'trash', label: i18n.t('Trash') },
];

export const FTP_OPTIONS = [
  { value: "", label: ""},
  { value: "netia", label: "Netia"},
  { value: "ftpclassic", label: "FTP"}
]